import React, {
    ReactElement, useState,
} from "react";
import { Form } from "react-bootstrap";
import {
    WorkflowService as ApiWorkflowService,
    FieldTypedValue,
    FormField,
    GetAllIntegrationsDocument,
    GetWorkflowServiceDocument, GetWorkflowServicesDocument,
    useInstallWorkflowServiceMutation,
} from "../../../../__generated__/api";
import Confirm from "../../../../components/confirm/Confirm";
import FieldTypeValueDisplay from "../../../../components/form-field/FieldTypeValueDisplay";
import FormGroup from "../../../../components/theme/form-group/FormGroup";
import Text from "../../../../components/theme/text/Text";
import { LoggingHandler } from "../../../../contexts/logging/LoggingContext";
import { useTheme } from "../../../../contexts/Theme";
import Styles from "./ServicesCardSection.module.scss";
import Drawer from "../../../../components/theme/drawer/Drawer";

export function WorkflowServiceInstall({
    service, onDone, isInstalling, onCompletedUrl,
}: {
    service: ApiWorkflowService;
    onDone: () => void;
    onCompletedUrl?: string;
    isInstalling: boolean
}): ReactElement {
    const [apiKey, setApiKey] = useState("");
    const [installFields, setInstallFields] = useState<FieldTypedValue[]>([]);

    const theme = useTheme();
    const id = service.id as string;
    const [install] = useInstallWorkflowServiceMutation({
        refetchQueries: [
            { query: GetWorkflowServiceDocument, variables: { id } },
            { query: GetWorkflowServicesDocument },
            { query: GetAllIntegrationsDocument },

        ],
    });

    const confirmSetup = () => {
        onDone();
        if (!service) {
            return;
        }
        LoggingHandler.instance.wrap(async () => {
            const response = await install({
                variables: {
                    install: {
                        id,
                        apiKey: !service?.connection?.apiKey ? undefined : {
                            input: installFields,
                            apiKey,
                        },
                        manual: !service.connection?.manual ? undefined : {
                            input: installFields,
                        },
                        oauth: !service?.connection?.oauth ? undefined : {
                            input: installFields,
                            redirectUrl: onCompletedUrl ?? window.location.href,
                        },
                    },
                },
            });
            const redirect = response.data?.workflowServiceInstall.redirectUrl;
            if (redirect) {
                window.open(redirect);
            }
        });
    };
    const serviceConnection = service.connection?.apiKey ?? service.connection?.manual;

    return (
        <Confirm
            shouldShow={isInstalling}
            // saveButtonText="Install"
            // onSave={() => confirmSetup()}
            // as="form"
            title={`Install ${service.name}`}
            onHide={() => onDone()}
            className={Styles["install-service"]}
            closeText="Cancel"
            onConfirm={() => confirmSetup()}
            confirmText="Install"
            dialogClassName={Styles["install-service"]}
            isDefaultBackground
        >
            <div>

                {serviceConnection && (
                    <div className={Styles["install-fields"]}>
                        <Form.Group className="my-3">
                            {service.connection?.apiKey && (
                                <FormGroup
                                    label={service.connection.apiKey.apiKeyFieldName ?? "API Key"}
                                    type="password"
                                    placeholder={service.connection.apiKey.placeholder ?? "abc123"}
                                    required={service.connection.apiKey.isRequired ?? true}
                                    onChange={evt => setApiKey(evt.target.value)}
                                    value={apiKey}
                                    size="small"
                                    helpText={service.connection.apiKey.instructions}
                                />
                            )}

                            {serviceConnection.input?.map(field => (
                                <FieldTypeValueDisplay
                                    key={field.id}
                                    useFormGroup
                                    field={field as FormField}
                                    onChange={changedValue => {
                                        const index = installFields.findIndex(row => row.fieldId === field.id);
                                        if (index >= 0) {
                                            installFields[index] = changedValue;
                                        } else {
                                            installFields.push(changedValue);
                                        }

                                        setInstallFields(Array.from(installFields));
                                    }}
                                />

                            ))}
                        </Form.Group>
                    </div>
                )}
                {service.connection?.oauth && (
                    <div className={Styles["install-fields"]}>
                        {service.connection.oauth.instructions && (
                            <Text as="div" textVariant="body-2-regular" className={Styles["install-instructions"]}>
                                {service.connection.oauth.instructions}
                            </Text>
                        )}

                        {service.connection.oauth.input?.map(field => (
                            <FieldTypeValueDisplay
                                key={field.id}
                                useFormGroup
                                field={field as FormField}
                                onChange={changedValue => {
                                    const index = installFields.findIndex(row => row.fieldId === field.id);
                                    if (index >= 0) {
                                        installFields[index] = changedValue;
                                    } else {
                                        installFields.push(changedValue);
                                    }

                                    setInstallFields(Array.from(installFields));
                                }}
                            />

                        ))}
                    </div>
                )}
            </div>
        </Confirm>
    );
}
WorkflowServiceInstall.defaultProps = {
    onCompletedUrl: undefined,
};

export default function useServiceInstall() {
    const [installingService, setInstalling] = useState<ApiWorkflowService>();
    return {
        element: installingService ? (
            <WorkflowServiceInstall
                service={installingService as ApiWorkflowService}
                isInstalling={installingService != null}
                onDone={() => setInstalling(undefined)}
            />
        ) : undefined,
        onInstall: (service: ApiWorkflowService) => setInstalling(service),
    };
}
